<div class="db-add-domain-list-dialog">
    <div class="db-add-domain-list-dialog__website-link mb10" *ngIf="!!websiteUrl">
        <i class="db-icon db-icon-ds-globus"></i>
        <span>{{websiteUrl}}</span>
    </div>
    <h3 class="mb10">{{'text_addDomainToWebsiteTitle' | dbText}}</h3>
    <div class="db-add-domain-list-dialog__footer mt30">
        <button class="ds-btn" (click)="activeModal.close()" [ngClass]="{'ds-btn-disabled': loading}"><span>{{'text_cancel' | dbText }}</span></button>
        <button class="ds-btn-black" (click)="linkDomain()" [ngClass]="{'ds-btn-disabled': loading}">
            <span *ngIf="!loading">{{( 'text_addDomainToWebsiteGetDomain') | dbText }}</span>
            <db-loading-circular-spinner class="sl-add-domain-dialog-loader" *ngIf="loading"></db-loading-circular-spinner>
        </button>
    </div>
</div>
